








































































import Vue from "vue";
//import { mapGetters } from "vuex";
import handleCanvas from "@/mixin/handleCanvas";
import { mapGetters } from "vuex";

export default Vue.extend({
  mixins: [handleCanvas],
  //props: {
  //  msg: String,
  //},
  mounted() {
    (this as any).updateCanvas();
  },
  methods: {
    selectedClass(num) {
      return this.getImageIndex == num ? "selected" : "";
    },
  },
  computed: {
    imageIndexBack() {
      return (this as any).getImageIndex - 1;
    },
    imageIndexNext() {
      return (this as any).getImageIndex + 1;
    },
    getImageIndex(): number {
      return this.getOptions["imageIndex"];
    },

    ...mapGetters({
      //getCanvasDom: "editor/getCanvasDom",
      getOptions: "editor/getOptions",
    }),
  },
});
